import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import { chooseReturnMethod } from '../../../actions/order';

import StoreOrUps from './StoreOrUps';
import UpsOnly from './UpsOnly';
import { flagEnabled } from '../../../helpers/featureFlags';
import { RETURNS_CONFIRMATION_ID, RETURNS_SELECT_DEVICE, subst } from '../../../helpers/routes';

const ReturnMethod = (props) => {
  const { confirmation, selectedDevices } = props;

  if (confirmation) {
    return <Redirect to={subst(RETURNS_CONFIRMATION_ID, { id: confirmation.returnOrderId })} />;
  }

  if (!selectedDevices) {
    return <Redirect to={RETURNS_SELECT_DEVICE} />;
  }
  return flagEnabled('device-returns.enableXfinityStore') ? <StoreOrUps {...props} /> : <UpsOnly {...props} />;
};

const mapStateToProps = state => ({
  selectedDevices: state.order.selectedDevices,
  initialValues: {
    method: 'xfinityStore',
  },
  submitLoading: state.order.submitLoading,
  confirmation: state.order.confirmation,
  submitError: state.order.submitError,
});

const mapDispatchToProps = dispatch => ({
  handleChooseReturnMethod: bindActionCreators(chooseReturnMethod, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnMethod);
